import React, { useContext, useState, useEffect, useRef } from "react";
import "../../styles/preparepdf.css";

import Sign from "../../assets/signature.png";
import Stamp from "../../assets/stamp.png";
import { ShareContext } from "../../context/ShareContext";

import { time } from "../../data/time";
import { useNavigate, useLocation, Link } from "react-router-dom";
import * as Constants from "../../constants";
import BackLoader from "../../components/backloader";
import Seal from "../../assets/seal.png";
import Sign2 from "../../assets/sign.png";

import JisPrompt from "../../components/jisprompt";
import JisAlert from "../../components/jisalert";
import { green, red } from "@mui/material/colors";
import moment from "moment";
import DynamicIcon from "../dynamicicon";
import JisButton from "../controls/jisButton";
import VirtualCallAudit from "./VirtualCallAudit";
import JisDialogForm from "../formdialog";
import PdfViewer from "../controls/pdfviewer";

function JisPreparePdf({
  pdfdoc,
  docInfo,
  isLegal = true,
  onInstumentAppended,
  doctype = "document",
   onDone,
  scheduleButtonText,
  onSchedule,
  docUploadId,
  isPaid,
  onGoToNextIncomplete,
  isCommissioned,
  onReplace
 
}) {
  const {
    sweared,
    isCfo,
    isThirdOpt,
    setWhichUpload,
    profile,
    token,
    frequentData,
    setIsExpired,
  } = useContext(ShareContext);

  const item = docInfo;
  console.log(profile, "profilea");
  const cashier_stamp = `${Constants.rooturl}/resources/special/cashier_stamp.png`; //image path
  const urlSaveInst = `${Constants.apiUrl}/filing/uploadinstrument`;
  const urlInstrument = `${Constants.apiUrl}/filing/instrument`;
  const cashierSeal_path = `${Constants.rooturl}/resources/special`;

  const [currectdoc, setCurrentDoc] = useState(pdfdoc); //
  const [cfoWarn, setCfoWarn] = useState(false);
  const [isDialog, setIsDialog] = useState(false);
  const [doc, setDocument] = useState({ uplines: [], uplinesigns: [] });
  const [isLoading, setIsLoading] = useState(false);
  const [posPoint, setPosPoint] = useState({}); //this is for items that are yet added passport 1, Seal 2, Signature 3  {x--cord,y - cord,show bool,docid  instype, imgurl}
  const [seal, setSeal] = useState("");
  const [passport, setPassport] = useState("");
  const [sign, setSign] = useState("");
  const [initial, setInitial] = useState("");
  const [stamp, setStamp] = useState("");
  const [pageIndex, setPageIndex] = useState(0);
  const [isSaved, setIsSaved] = useState(false);
  const [cashier_seal, setCashierSeal] = useState("");
  const [permissionList, setDocPermissionList] = useState(new Set());
  const [incom, setIncom] = useState(0);
  const [rework, setRework] = useState({openRework:false, docid:null, reason:null})
 const [err, setErr] = useState("");

  const imageRef = useRef(null);

  const [currentdate, setCurrendate] = useState(new Date());
  const [timestamp, setTimestamp] = useState(
    moment(currentdate).format("DD/MM/YYYY hh:mm a"),
  );
  //load documents first, then load one by one
  const [posId, setPosId] = useState(0); //this is the main guy that is doing the selection
  const dragRef = useRef({ isDragging: false });
  const [imgs, setImgs] = useState([]);
  const [activeFile, setActiveFile] = useState({});
  const [isReplace, setIsReplace]=  useState(false);
  const [sFile, setSFile] = useState(null);
const [isPreview, setIsPreview] = useState(false);
 const [previewPath, setPreviewPath] = useState(false);

  const needpermission = "Document saved successfully! Wait for the CFO to commission your document ";
  const noneedpermission ="Document saved successfully! Wait for the CFO to initial your document";
  const cfoMsg = "";
  const finalmsgcase = `You have worked on all document(s), the case will now move to Process Section Assessors' Queue `;

  const finalmsgaffidavit ="You have worked on the affidavit. The process is completed now";
  const finalmssheriff = `Document processed successfully! You have worked on Service Sheriff affidavit. `;
  const finalsettlement = `Term of settlement processed successfully! `;

  const prepareWritoffifa ="Document saved successfully! Wait for the ACR for Review ";
  const finalwritoffifa = `Case is going to Head of Process for further review`;
  const finalwarrant = `Case is going to Head of Process for Notice of Attachment`;
  const finalnotice ="The Hearing notice is Prepared. Will be waiting with selected Service sheriff to serve";

  const rework_note="Document rework is done, other document rework exist for this case either with Legal Counsel or CFO";
  const rework_final="Case moved to Screener or ACR to continue";
  // const permissionList =
  //   item.caseType == "adr"
  //     ? Constants.DocPermissionList_ADR
  //     : Constants.DocPermissionList;

  const onSaveInst = () => {
    onUploadIns();
  };

  const [imgPrev, setImgPrev] = useState({ data: "", type: "", open: false });
  const [alert, setAlert] = useState({ open: false, title: "", subtitle: "" });

  const [prompt, setPrompt] = useState({
    open: false,
    title: "",
    subtitle: "",
  });

  var pageRef = useRef(null);

  const navigate = useNavigate();

  const onOk = () => {
    setAlert({ ...alert, open: false });
  };
  const onGotoDashboard = () => {
    setAlert({ ...alert, open: false });
    console.log("on going to dashboard");
    console.log(item, "item here");

if (typeof onDone === "function")
      onDone(currectdoc);
   
    if (item.type == "affidavit") {
      navigate("/cfo-affidavits");
    } else if (doctype == "sheriff") {
      navigate("/cfo-e-swearing-sheriff");
    } else if (doctype == "service-sheriff-sub") {
      navigate("/cfo-e-swearing-sheriff-substituted");
    } else if (doctype == "sheriff") {
      navigate("/cfo-e-swearing-sheriff");
    } else if (doctype == "writ-of-fifa") {
      navigate("/acr-writ-of-fifa");
    } else if (doctype == "writ-warrant") {
      navigate("/judge-warrants");
    }else if (doctype == "rework") {
      navigate(isLegal? "/rework/legalcounsel":'/rework/cfo');
    }
     else {
      navigate("/cfo-e-swearing");
    }
  };

  const confirmCaseDoc = () => {
    navigate("/upload/documents");
    setWhichUpload("Third");
  };

  const navigateToAffidavit = () => {
    navigate("/affidavits");
  };

  useEffect(() => {
    onLoadInstrument();
    console.log("am here in usefect in preparePdf************");
    console.log(pdfdoc);
    setCurrentDoc(pdfdoc);
    setImgs([]);
    setPosId(0);
    dragRef.current = { isDragging: false };
    setCashierSeal(`${cashierSeal_path}/cashier_seal_${pdfdoc.upline?.id}.png`);
    onLoadPermissions();
    setPageIndex(0);
    setPosPoint({});
  }, [pdfdoc]);

  const onLoadPermissions = async () => {
    //for account registration

    try {
      const resp = await fetch(
        `${Constants.apiUrl}/setup/gazette-lines-permission`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const data = await resp.json();
      if (data.code == 0) {
        console.log("list of permissions");
        console.log(data.ids);
        setDocPermissionList(new Set(data.ids));
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (imageRef.current != null) {
      handleImageLoad();
    }
  }, [imageRef.current]);

  //drag issue - pointer events (works on mouse and touch)
  const onPointerDownInstr = (e, instid) => {
    e.preventDefault();
    e.currentTarget.setPointerCapture(e.pointerId);

    const currentPos = posPoint[instid] || { x: 0, y: 0 };
    dragRef.current = {
      isDragging: true,
      posId: instid,
      startClientX: e.clientX,
      startClientY: e.clientY,
      startX: currentPos.x,
      startY: currentPos.y,
    };
  };

  const onPointerMoveInstr = (e, instid) => {
    const drag = dragRef.current;
    if (!drag.isDragging || drag.posId !== instid) return;
    e.preventDefault();

    const x = drag.startX + (e.clientX - drag.startClientX);
    const y = drag.startY + (e.clientY - drag.startClientY);

    setPosPoint((prev) => {
      const updated = { ...prev, [instid]: { ...prev[instid], x, y } };
      return updated;
    });
    setImgs((prev) =>
      prev.map((item) => (item.id === instid ? { ...item, x, y } : item)),
    );
  };

  const onPointerUpInstr = (e, instid) => {
    const drag = dragRef.current;
    if (!drag.isDragging) return;

    const x = drag.startX + (e.clientX - drag.startClientX);

    if (x > 650) {
      setPosPoint((prev) => {
        const updated = { ...prev };
        delete updated[instid];
        return updated;
      });
      setImgs((prev) => prev.filter((item) => item.id !== instid));
    }

    dragRef.current = { isDragging: false };
  };

  const onPointerCancelInstr = () => {
    dragRef.current = { isDragging: false };
  };

  //passport 1, Seal 2, Signature 3
  const onAppendPassport = () => {
    /*   if(pageIndex != currectdoc.filenames.length-1){
            setAlert(  {open:true,title:'Append ', subtitle:'You can only append to last page', onOk});
          return;
        } */

    if (passport == "") {
      setAlert({
        icon: "warning",
        open: true,
        title: "Append Passport",
        subtitle: "Please upload your passport",
        onOk,
      });
      return;
    }

    var _pos = { ...posPoint };
    _pos[1] = {
      x: 0,
      y: 0,
      show: true,
      instype: "Passport",
      imgurl: passport,
      id: 1,
      start: {},
      pageIndex,
    };
    setPosId(1);
    setPosPoint(_pos);
    setImgs(Object.values(_pos));
    console.log("the value");
    console.log(_pos);
  };

  const onAppendSeal = () => {
    if (seal == "") {
      setAlert({
        icon: "warning",
        open: true,
        title: "Append Seal",
        subtitle: "Please upload your seal",
        onOk,
      });
      return;
    }

    console.log(imgs);
    var _pos = { ...posPoint };
    _pos[2] = {
      x: 0,
      y: 0,
      show: true,
      instype: "Seal",
      imgurl: seal,
      id: 2,
      start: {},
      pageIndex,
    };
    setPosId(2);
    setPosPoint(_pos);
    setImgs(Object.values(_pos));
    console.log("the value");
    console.log(_pos);
  };

  const onAppendCashierSeal = () => {
    if (profile.role == "LegalCounsel" || profile.role == "Customer") {
      return;
    }

    console.log(imgs);
    var _pos = { ...posPoint };
    _pos[10] = {
      x: 0,
      y: 0,
      show: true,
      instype: "Cashier Seal",
      imgurl: cashier_seal,
      id: 10,
      start: {},
      pageIndex,
    };
    setPosId(10);
    setPosPoint(_pos);
    setImgs(Object.values(_pos));
    console.log("the value");
    console.log(_pos);
  };
  const onAppendCashierStamp = () => {
    if (profile.role == "LegalCounsel" || profile.role == "Customer") {
      return;
    }

    console.log(imgs);
    var _pos = { ...posPoint };
    _pos[11] = {
      x: 0,
      y: 0,
      show: true,
      instype: "Cashier Stamp",
      imgurl: cashier_stamp,
      id: 11,
      start: {},
      pageIndex,
    };
    setPosId(11);
    setPosPoint(_pos);
    setImgs(Object.values(_pos));
    console.log("the value");
    console.log(_pos);
  };

  const onAppendSignature = () => {
    if (
      permissionList.has(currectdoc.upline?.gazetteItemId) &&
      !currectdoc.upline?.allowSign
    ) {
      //  setAlert(  {open:true,title:'Append ', subtitle:'Wait for the CFO to authorize appending a signature on the document. This approval will be granted during the scheduled video virtual call". if you are sure the CFO has approved. Please click Next and Previous to the same file to refresh', onOk});
      setAlert({
        icon: "warning",
        open: true,
        title: "Append ",
        subtitle:
          "Wait for the CFO to authorize appending a signature on the document. This approval will be granted during the scheduled virtual call",
        onOk,
      });
      return;
    }

    if (sign == "") {
      setAlert({
        icon: "warning",
        open: true,
        title: "Append Signature",
        subtitle: "Please upload your Signature",
        onOk,
      });
      return;
    }
    var _pos = { ...posPoint };
    _pos[3] = {
      x: 0,
      y: 0,
      show: true,
      instype: "signature",
      imgurl: sign,
      id: 3,
      start: {},
      pageIndex,
    };
    setPosId(3);
    setPosPoint(_pos);
    setImgs(Object.values(_pos));

    console.log("the value");
    console.log(_pos);
  };

  const onAppendInitial = () => {
    if (initial == "") {
      setAlert({
        icon: "warning",
        open: true,
        title: "Append Initial",
        subtitle: "Please upload your Initial",
        onOk,
      });
      return;
    }
    var _pos = { ...posPoint };
    _pos[6] = {
      x: 0,
      y: 0,
      show: true,
      instype: "initial",
      imgurl: initial,
      id: 6,
      start: {},
      pageIndex,
    };
    setPosId(6);
    setPosPoint(_pos);
    setImgs(Object.values(_pos));

    console.log("the value");
    console.log(_pos);
  };

  const onAppendStamp = () => {
    if (stamp == "") {
      setAlert({
        icon: "warning",
        open: true,
        title: "Append Stamp",
        subtitle: "Please upload your Stamp",
        onOk,
      });
      return;
    }
    var _pos = { ...posPoint };
    _pos[4] = {
      x: 0,
      y: 0,
      show: true,
      instype: "stamp",
      imgurl: stamp,
      id: 4,
      start: {},
      pageIndex,
    };
    setPosId(4);
    setPosPoint(_pos);
    setImgs(Object.values(_pos));
    console.log("the value");
    console.log(_pos);
  };
  // The timestamp is text, not an image: measure its on-screen box so the server can
  // print it at exactly the size the user sees (it used to fall back to a tiny fixed size).
  const measureTimestamp = (id, el) => {
    if (!el) return;
    const rect = el.getBoundingClientRect();
    const w = Math.round(rect.width);
    const h = Math.round(rect.height);
    if (!w || !h) return;
    setPosPoint((prev) =>
      prev[id] &&
      (prev[id].displayWidth !== w || prev[id].displayHeight !== h)
        ? { ...prev, [id]: { ...prev[id], displayWidth: w, displayHeight: h } }
        : prev,
    );
    setImgs((prev) =>
      prev.some(
        (i) => i.id === id && (i.displayWidth !== w || i.displayHeight !== h),
      )
        ? prev.map((i) =>
            i.id === id ? { ...i, displayWidth: w, displayHeight: h } : i,
          )
        : prev,
    );
  };

  const onAppendTimestamp = () => {
    //5 for timestamp

    var _pos = { ...posPoint };
    _pos[5] = {
      x: 0,
      y: 0,
      show: true,
      instype: "timestamp",
      imgurl: "",
      id: 5,
      start: {},
      pageIndex,
      timestamp,
    };
    setPosId(5);
    setPosPoint(_pos);
    setImgs(Object.values(_pos));
    console.log("the value");
    console.log(_pos);
  };
  const onAppendTimestamp2 = () => {
    //5 for timestamp

    var _pos = { ...posPoint };
    _pos[7] = {
      x: 0,
      y: 0,
      show: true,
      instype: "timestamp",
      imgurl: "",
      id: 7,
      start: {},
      pageIndex,
      timestamp,
    };
    setPosId(7);
    setPosPoint(_pos);
    setImgs(Object.values(_pos));
    console.log("the value");
    console.log(_pos);
  };

  const getFinalSubtitle = (isDocVerified,incomplete) => {
    console.log(`inside getFinalSubtitle ${isDocVerified} incomplete ${incomplete}`)
    if (isDocVerified) {
      const caseCategory = Constants.getItemById(
        frequentData?.casecategories,
        docInfo.caseCategoryId,
      )?.categoryTitle?.toLowerCase();
      if (caseCategory === "general civil" || caseCategory === "commercial") {
        return "You have worked on all document(s), the case will now move to Screener Queue.";
      }
      return "You have worked on all document(s), the case will now move to ACR Queue.";
    }
    return onfinalMsg(incomplete);
  };

  const onfinalMsg = (incomplete) => {
console.log(`inside onfinalMsg item.type ${item.type} doctype ${doctype}`)
    if (typeof onDone === "function") {
        onDone(currectdoc);
      }
    if (item.type == "affidavit") {
      return finalmsgaffidavit;
    } else if (doctype == "sheriff") {
      return finalmssheriff;
    } else if (doctype == "settlement") {
      return finalsettlement;
    } else if (doctype == "service-sheriff-sub")
      return "You have worked on all doument(s). The case will now move to Case manger Queue";
    else if (doctype == "writ-of-fifa") {
      return finalwritoffifa;
    } else if (doctype == "writ-warrant") {
      return finalwarrant;
    } else if (doctype == "hearing-notice") {
      return finalnotice;
    } else if (doctype == "rework") {
      return incomplete==0? rework_final: rework_note;
    } else {
      return finalmsgcase;
    }
  };

 const onOk_Save = () => {
    console.log(`inside onOk_Save and doctype is ${doctype}`)
    setAlert({ ...alert, open: false });

    if (typeof onDone === "function") {
      console.log("called onDone in the component");
      onDone(currectdoc);
    } else {
      console.log(typeof onDone);
    }

    if (doctype == "rework") {
        navigate(isLegal? "/rework/legalcounsel":'/rework/cfo');
     
    }

  };

  const onSaveMsg = (incomplete) => {
    console.log(`inside on onSaveMsg and doctype is ${doctype} with incomplete ${incomplete}`)
    if (typeof onDone === "function") {
      console.log('onDone is invoked')
        onDone(currectdoc);
      }
    if (
      permissionList.has(currectdoc?.upline?.gazetteItemId) ||
      item.type == "affidavit"
    ) {
      return needpermission;
    } else if (doctype == "sheriff") {
      return finalmssheriff;
    } else if (doctype == "settlement") {
      return finalsettlement;
    } else if (doctype == "service-sheriff-sub")
      return "Document saved successfully! ";
    else if (doctype == "writ-of-fifa") {
      return prepareWritoffifa;
    } else if (doctype == "hearing-notice") {
      return finalnotice;
    } else if (doctype == "rework") {
        
      return incomplete==0?rework_final: rework_note;
    } else {
      return needpermission;
    }
  };
  const previewImage = async (event, inst) => {
    console.log("file read");
    const input = event.target;
    // const preview = document.getElementById('preview');
    console.log(input);
    if (input.files && input.files[0]) {
      var b64 = await Constants.toBase64(input.files[0]);
      setImgPrev({
        open: true,
        data: b64,
        type: inst,
        title: "Upload " + inst,
        file: input.files[0],
        onCancel: () => setImgPrev({ ...imgPrev, open: false }),
      });
      setActiveFile({
        open: true,
        data: b64,
        type: inst,
        title: "Upload " + inst,
        file: input.files[0],
        onCancel: () => setImgPrev({ ...imgPrev, open: false }),
        onOk: onSaveInst,
      });
      console.log("file read");

  
    }
  };

  const onAgree = () => {
    setImgPrev({ ...imgPrev, open: false });
    onSaveInst();
  };
  const onUploadIns = async () => {
    console.log("imgPrev data");
    console.log(imgPrev);

    setIsLoading(true);
    //setImgPrev({...imgPrev,open:true,data:e.target.result,type:inst, title:"Upload "+inst, });
    var ext = imgPrev.file.name.split(".")[1];
    var rdata = {
      base64: imgPrev.data.split(",")[1],
      instType: imgPrev.type,
      ext,
      changereason: "Initial",
    };
    // Sending the FormData using fetch
    fetch(urlSaveInst, {
      method: "POST",
      body: JSON.stringify(rdata),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setIsLoading(false);
        if (data.code == 0) {
          //saved already
          setImgPrev({ ...imgPrev, open: false });
          setAlert({
            ...alert,
            title: imgPrev.type,
            open: true,
            subtitle: `Saved ${imgPrev.type} successfully`,
            onOk,
          });
          console.log(
            `data instPath ${data.instPath} , imgPrev.type ${imgPrev.type}`,
          );
          onSetImg(data.instPath, imgPrev.type);
        } else if (data.code == -10) {
          setIsExpired(true);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        setIsLoading(false);
      });
  };

  const goToNext = () => {
    onOk();
    
    if (typeof onGoToNextIncomplete === "function") {
      onGoToNextIncomplete();
    }
  };

  const onAppendOnServer = () => {
    setPrompt({ open: false });

  const imgEl = imageRef.current;

  if (!imgEl) {
    setAlert({
      open: true,
      icon: "warning",
      title: "Document not ready",
      subtitle: "Please wait for the document page to finish loading.",
      onOk,
    });
    return;
  }

  const renderedWidth = imgEl.clientWidth;
  const renderedHeight = imgEl.clientHeight;
  const naturalWidth = imgEl.naturalWidth;
  const naturalHeight = imgEl.naturalHeight;

  if (
    renderedWidth <= 0 ||
    renderedHeight <= 0 ||
    naturalWidth <= 0 ||
    naturalHeight <= 0
  ) {
    setAlert({
      open: true,
      icon: "warning",
      title: "Invalid document size",
      subtitle: "The document dimensions could not be determined.",
      onOk,
    });
    return;
  }

  const scaleX = naturalWidth / renderedWidth;
  const scaleY = naturalHeight / renderedHeight;

  const instruments = imgs.map((instrument) => {
    const renderedInstrumentWidth =
      instrument.displayWidth ??
      posPoint[instrument.id]?.displayWidth ??
      100;

    const renderedInstrumentHeight =
      instrument.displayHeight ??
      posPoint[instrument.id]?.displayHeight ??
      100;

    return {
      instrumentType: instrument.instype,
      x: Math.round(instrument.x * scaleX),
      y: Math.round(instrument.y * scaleY),
      url: instrument.imgurl,
      pageIndex: instrument.pageIndex,
      timestamp,

      // Dimensions in natural PNG pixel coordinates
      displayWidth: Math.round(renderedInstrumentWidth * scaleX),
      displayHeight: Math.round(renderedInstrumentHeight * scaleY),
    };
  });

  if (instruments.length === 0) {
    setAlert({
      open: true,
      icon: "warning",
      title: "No instrument",
      subtitle: "No instrument has been positioned on the document.",
      onOk,
    });
    return;
  }

  const ratio = naturalWidth / naturalHeight;

  const url =
    `${Constants.apiUrl}/filing/appendInstrument/` +
    `${currectdoc.upline?.id}/` +
    `${naturalWidth}/` +
    `${naturalHeight}/` +
    `${ratio}/` +
    `${isLegal}`;




   // const url = `${Constants.apiUrl}/filing/appendInstrument/${currectdoc.upline?.id}/${natW}/${natH}/${ar}/${isLegal}`;


    if (instruments.length == 0) {
      setAlert({
        ...alert,
        icon: "warning",
        title: imgPrev.type,
        open: true,
        subtitle: `Its either you did not append any instrument or there is no other instrument required.`,
        onOk,
      });
      return;
    }
    setIsLoading(true);
    console.log("server positioning *****************");
    console.log(instruments);
    // Sending the FormData using fetch
    fetch(url, {
      method: "POST",
      body: JSON.stringify(instruments),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setIsLoading(false);
        if (data.code == 0) {
          //saved already
          setImgPrev({ ...imgPrev, open: false });
          //if profile.role=='legal councel'
           setIncom(data.incompleted);
          if (isLegal) {
            console.log(`islegal***`)
            setAlert({
              ...alert,
              open: true,
              title: "Save Document",
              open: true,
              subtitle: onSaveMsg(data.incompleted),
              onOk: onOk_Save,
            });
          } 
          else {
           console.log(`not islegal***`)
            if (data.incompleted == 0 || doctype=='rework') {
              setAlert({
                ...alert,
                open: true,
                title: "Process Document(s)",
                subtitle: getFinalSubtitle(data.isVerified,data.incompleted),
                onOk: onGotoDashboard,
              });
            } else {
              setAlert({
                ...alert,
                open: true,
                title: "Process Document",
                subtitle: `Processed Successfully. Document remain to be processed ${data.incompleted}`,
                onOk: goToNext,
              });
            }
          }
          onInstumentAppended(data);
          UpdateInst(currectdoc.upline?.id);
          setPrompt({ ...prompt, open: false });
        } else if (data.code == -10) {
          setIsExpired(true);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        setIsLoading(false);
         setAlert({
            open: true,
            icon: "error",
            title: "Instrument placement failed",
            subtitle: error.message,
            onOk,
          });
      });
  };

  const UpdateInst = (id) => {
    //the id of the upline

    var uplines = doc.uplines;
    var pass = posPoint[1];
    var seal = posPoint[2];
    var sign = posPoint[3];
    // var updatedup
    if (isLegal) {
      if (pass != null) {
        uplines = uplines.map((l) =>
          l.id == id ? { ...l, passportPath: "uploaded" } : l,
        );
      }
      if (seal != null) {
        uplines = uplines.map((l) =>
          l.id == id ? { ...l, sealPath: "uploaded" } : l,
        );
      }
      if (sign != null) {
        uplines = uplines.map((l) =>
          l.id == id ? { ...l, signaturePath: "uploaded" } : l,
        );
      }
    } else {
      /* if(pass!=null){
                    uplines= uplines.map(l=>l.id==id?{...l,passportPath:'uploaded'}:l)
                  } */
      if (seal != null) {
        uplines = uplines.map((l) =>
          l.id == id ? { ...l, oathSealPath: "uploaded" } : l,
        );
      }
      if (sign != null) {
        uplines = uplines.map((l) =>
          l.id == id ? { ...l, oathSignature: "uploaded" } : l,
        );
      }
      if (stamp != null) {
        uplines = uplines.map((l) =>
          l.id == id ? { ...l, oathStamp: "uploaded" } : l,
        );
      }
    }

    setDocument({ uplines });
  };

  const onSetImg = (path, type) => {
    const ct = type.toLowerCase();
    if (ct == "seal") {
      setSeal(`${Constants.docUrl}instrument/${path}`);
    } else if (ct == "passport") {
      setPassport(`${Constants.docUrl}instrument/${path}`);
    } else if (ct == "signature") {
      setSign(`${Constants.docUrl}instrument/${path}`);
    } else if (ct == "stamp") {
      setStamp(`${Constants.docUrl}instrument/${path}`);
    } else if (ct == "initial") {
      setInitial(`${Constants.docUrl}instrument/${path}`);
    }
    /*  else if(ct=='timestamp'){
            setTimestamp(  `${Constants.docUrl}instrument/${path}`);
        } */
  };

  const onLoadInstrument = async () => {
    //for account registration
    console.log(`the calling url ${urlInstrument}`);
    try {
      setIsLoading(true);
      const resp = await fetch(urlInstrument, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await resp.json();
      setIsLoading(false);
      if (data.code == 0) {
        //check if it contain any of the items
        console.log("the loaded instrument");
        console.log(data, "fuck this here");

        for (const x of data.inst) {
          onSetImg(x.instPath, x.instrument);
        }
      } else if (data.code == -10) {
        setIsExpired(true);
      }
    } catch (error) {
      setIsLoading(false);
      console.error(error);
    }
  };

  const onSavePostion = () => {
    setPrompt({
      icon: "info",
      open: true,
      title: "Save Instrument Positioning",
      subtitle:
        "Please note that saving instrument positioning will modify the document and the process is not reversable. Do you want to continue?",
      onCancel: () => {
        setPrompt({ ...prompt, open: false });
      },
      onOk: onAppendOnServer,
    });
  };

  const onNextPage = () => {
    if (pageIndex < currectdoc.filenames.length - 1) {
      var ipage = pageIndex + 1;
      setPageIndex(ipage);
    } else {
      console.log("its not there again " + pageIndex);
    }
  };

  const onPrevPage = () => {
    if (pageIndex > 0) {
      var ipage = pageIndex - 1;
      setPageIndex(ipage);
    } else {
      console.log("its not there again " + pageIndex);
    }
  };

  const onAllowSign = (e) => {
    console.log(e.target.value);
    onAllow(true, "sign");
  };
  const onAllowSeal = (e) => {
    console.log(e.target.value);
    onAllow(true, "seal");
  };

  const onAllow = (isAllow, instType) => {
    const url = `${Constants.apiUrl}/filing/allowinstrument/${currectdoc.upline?.id}`;
    var ll = {
      uplineId: currectdoc.upline?.id,
      isAllow,
      instType,
      cfoUserid: profile.username,
    };
    setIsLoading(true);

    fetch(url, {
      method: "POST",
      body: JSON.stringify(ll),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setIsLoading(false);
        if (data.code == 0) {
          //saved already
          if (instType == "seal") {
            var up = currectdoc.upline;
            up.allowSeal = isAllow;
            setCurrentDoc({ ...currectdoc, upline: up });
          } else if (instType == "sign") {
            var up = currectdoc.upline;
            up.allowSign = isAllow;
            setCurrentDoc({ ...currectdoc, upline: up });
          }
        } else if (data.code == -10) {
          setIsExpired(true);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        setIsLoading(false);
      });
  };

  const onCloseRework=()=>{
    console.log('onclose rework')
    setRework({openRework:false})
    setAlert({...alert,open:false})
  }

 const onCloseChange=()=>{
    
    setIsReplace(false)
    setAlert({...alert,open:false})
  } 

  //about image and its rendered

  const [dynamicWidth, setDynamicWidth] = useState(650);
  const [dynamicHeight, setDynamicHeight] = useState(900);
  const [naturalImgWidth, setNaturalImgWidth] = useState(650);
  const [naturalImgHeight, setNaturalImgHeight] = useState(900);
  const staticHeight = 900;
  const [aspectRatio, setAspectRatio] = useState(null);
  const handleImageLoad = () => {
    if (imageRef.current) {
      const { naturalWidth, naturalHeight } = imageRef.current;
      setAspectRatio((naturalWidth / naturalHeight).toFixed(2));
      setNaturalImgWidth(naturalWidth);
      setNaturalImgHeight(naturalHeight);
      // Use rAF so layout is fully complete before reading clientWidth/clientHeight
      requestAnimationFrame(() => {
        if (imageRef.current) {
          const width = imageRef.current.clientWidth;
          const height = imageRef.current.clientHeight;
          if (width > 0) setDynamicWidth(width);
          if (height > 0) setDynamicHeight(height);
        }
      });
    }
  };


  //end image rendered

  const onSaveRework = async (e) => {
         e.preventDefault();
      var ditem={docid:currectdoc.upline?.id, docUploadId:currectdoc.upline?.docUploadId,reason:rework.reason};

      setIsLoading(true);
      try {
        const resp = await fetch(
          `${Constants.apiUrl}/filing/save-docline-rework`,
          {
            method: "POST",
            body: JSON.stringify(ditem ),
            headers: {
              "Content-Type": "application/json, text/plain",
              "Authorization": `Bearer ${token}`, 
          },
            
          }
        );
  
        const data = await resp.json();
        setIsLoading(false);
        console.log(data);
        if (data.code == 0) { 
           setAlert({
              open: true,
              subtitle: "Rework reason sent successfully",
              onOk:onCloseRework
            });
          setRework({...rework, openRework:false});
         
        } else if (data.code == -10) {
          setIsExpired(true);
        } else {
          //there is an error
          setErr(data.status);
        }
      } catch (error) {
        setIsLoading(false);
        console.error(error);
        setErr(Constants.serverErr);
        // onMove();
      }
    }; 
   const onReuploadDocument=()=>{
      setIsReplace(true);
   }
   const onReworkCompleted=async()=>{
      // update complete rework
        const uploadurl = `${Constants.apiUrl}/filing/rework-completed/${currectdoc.upline?.id}/${isLegal}`;
    var obj = {
      
    };

    setIsLoading(true);
    fetch(uploadurl, {
      method: "POST",
      body: JSON.stringify(obj),
      headers: {
        "Content-Type": "application/json, text/plain",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setIsLoading(false);
        if (data.code == 0) {
          //saved already
         
          setAlert({
            open: true,
            title: "Rework Completed",
            subtitle: "Rework completed successfully",
            onOk:CompleteReplacement
          });
         
        } else if (data.code == -10) {
          setIsExpired(true);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        setIsLoading(false);
      });
   }
   const handleUploadChange = async (e) => {
       const files = e.target.files;
       console.log(files[0]);
       var b64 = await Constants.toBase64(files[0]);
       var path = URL.createObjectURL(files[0]);
       var fname = Constants.ReduceFilename(files[0]?.name);
   
       var a = {
         path,
         base64: b64.split(",")[1],
         filename: fname,
         base64Ext: b64.split(",")[0],
         comment: '',
       };
   
       setSFile(a);
       console.log(a);
     };
     const onPreview = (obj) => {
    setIsPreview(true);
    setPreviewPath(obj.path);
  };
  const onSaveFile = () => {
    if (sFile == null) {
      return;
    }
    onUploadFiles2();
  };
const onUploadFiles2 = async () => {
    const uploadurl = `${Constants.apiUrl}/filing/replace-document/${currectdoc.upline?.docUploadId}/${currectdoc.upline?.id}`;
    var upline = {
      id: 0,
      uplineType: "attest",
      base64: sFile.base64,
      base64Ext: sFile.base64Ext,
      templateId: 0,
      templatetitle: "",
      filename: sFile.filename,
      docuploadid: 0,
      comment: '',
    };

    setIsLoading(true);
    fetch(uploadurl, {
      method: "POST",
      body: JSON.stringify(upline),
      headers: {
        "Content-Type": "application/json, text/plain",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setIsLoading(false);
        if (data.code == 0) {
          //saved already
          setIsReplace(false);

          setAlert({
            open: true,
            title: "Document Replacement",
            subtitle: "Document Replacement sucessfully",
            onOk:CompleteReplacement
          });
         
        } else if (data.code == -10) {
          setIsExpired(true);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        setIsLoading(false);
      });
  };

  const CompleteReplacement=()=>{
      //reload the singular object
      setAlert({open:false});
      setSFile(null);
      onReplace();
  }

  return (
    <div className="view-doc">
      <div className="body">
        <div className="document">
          <div
            className="doc-side"
            style={{ maxWidth: "684px", width: "100%", flex: "auto" }}
          >
            {/* <div className="top-bar">
                      
                        <div className="namedoc">
                            <p>Current File: <span>{currectdoc.upline?.documentTitle}</span> </p>
                        </div>
                     
                    </div>   */}
            <div
              className="wrapper"
              style={{
                backgroundColor: "GrayText",
                padding: 0,
                overflow: "auto",
                width: "100%",
                maxWidth: "100%",
                display: "flex",
              }}
              ref={pageRef}
            >
              
              {/* Image + instrument overlays share a tight relative container so
                  x=0,y=0 in overlay space == top-left of the document image,
                  matching the coordinate space the server expects. */}
              {currectdoc.filenames.length > 0 && (
                <div style={{ position: "relative", display: "inline-block", flexShrink: 0 }}>
                  <img
                    ref={imageRef}
                    onLoad={handleImageLoad}
                    src={Constants.AbsoluteFiletoRelative(
                      pdfdoc.filenames[pageIndex],
                    )}
                    style={{
                      maxHeight: staticHeight,
                      maxWidth: "100%",
                      height: "auto",
                      width: "auto",
                      margin: 0,
                      display: "block",
                      objectFit: "contain",
                    }}
                  />

                  {/* Instruments — absolutely positioned within image bounds */}
                  {imgs.map((item, id) => {
                    return (
                      item.pageIndex == pageIndex && (
                        <div key={id}>
                          {item.id == 5 || item.id == 7 ? (
                            <div
                              ref={(el) => measureTimestamp(item.id, el)}
                              style={{
                                margin: 0,
                                padding: 0,
                                position: "absolute",
                                top: item.y,
                                left: item.x,
                                cursor: "grab",
                                touchAction: "none",
                                userSelect: "none",
                                whiteSpace: "nowrap",
                                lineHeight: 1,
                                // same face the server uses to draw the timestamp
                                fontFamily: '"Bookman Old Style", "Bookman", serif',
                              }}
                              onPointerDown={(e) => onPointerDownInstr(e, item.id)}
                              onPointerMove={(e) => onPointerMoveInstr(e, item.id)}
                              onPointerUp={(e) => onPointerUpInstr(e, item.id)}
                              onPointerCancel={onPointerCancelInstr}
                            >
                              <strong>
                                {moment(currentdate).format("DD/MM/YYYY hh:mm a")}
                              </strong>{" "}
                            </div>
                          ) : (
                            <img
                            src={item.imgurl}
                            draggable={false}
                            style={{
                              height: item.previewHeight ?? 100,
                              width: "auto",
                              maxWidth: "none",
                              margin: 0,
                              position: "absolute",
                              top: item.y,
                              left: item.x,
                              cursor: "grab",
                              touchAction: "none",
                              userSelect: "none",
                            }}
                            onLoad={(event) => {
                              const element = event.currentTarget;

                              const dimensions = {
                                displayWidth: element.getBoundingClientRect().width,
                                displayHeight: element.getBoundingClientRect().height,
                              };

                              setPosPoint((previous) => ({
                                ...previous,
                                [item.id]: {
                                  ...previous[item.id],
                                  ...dimensions,
                                },
                              }));

                              setImgs((previous) =>
                                previous.map((instrument) =>
                                  instrument.id === item.id
                                    ? {
                                        ...instrument,
                                        ...dimensions,
                                      }
                                    : instrument,
                                ),
                              );
                            }}
                            onPointerDown={(event) => onPointerDownInstr(event, item.id)}
                            onPointerMove={(event) => onPointerMoveInstr(event, item.id)}
                            onPointerUp={(event) => onPointerUpInstr(event, item.id)}
                            onPointerCancel={onPointerCancelInstr}
                          />
                          )}
                        </div>
                      )
                    );
                  })}
                </div>
              )}

              <div className="down">
                {currectdoc.filenames.length == 0 && (
                  <Link to={`/upload/documents/${item.caseFeeId}`}>
                    <span>Upload Files</span>{" "}
                  </Link>
                )}
                {currectdoc.filenames.length > 0 && (
                  <>
                    <p>
                      {pageIndex + 1} / {currectdoc.filenames.length}
                    </p>
                    <div className="pagination">
                      <button
                        onClick={onPrevPage}
                        disabled={pageIndex === 0}
                      >
                        <svg
                          width={11}
                          height={12}
                          viewBox="0 0 11 12"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g opacity="0.4">
                            <path
                              d="M10.0307 9.03887V2.00301C10.0307 0.459432 8.35631 -0.502312 7.02299 0.275454L0.992259 3.79338C-0.330752 4.56514 -0.330754 6.47674 0.992257 7.2485L7.02299 10.7664C8.3563 11.5442 10.0307 10.5824 10.0307 9.03887Z"
                              fill="#171D1A"
                            />
                          </g>
                        </svg>
                        <p>Previous</p>{" "}
                      </button>

                      <button
                        onClick={onNextPage}
                        disabled={
                          pageIndex === currectdoc.filenames.length - 1
                        }
                      >
                        <p>Next</p>
                        <svg
                          width={11}
                          height={12}
                          viewBox="0 0 11 12"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            opacity="0.4"
                            d="M0 9.03887V2.00301C0 0.459432 1.67443 -0.502312 3.00774 0.275454L9.03847 3.79338C10.3615 4.56514 10.3615 6.47674 9.03847 7.2485L3.00774 10.7664C1.67443 11.5442 0 10.5824 0 9.03887Z"
                            fill="#171D1A"
                          />
                        </svg>
                      </button>
                    </div>
                  </>
                )}

                {isCfo && (
                  <button onClick={() => setIsDialog(true)}>
                    Edit Schedule{" "}
                  </button>
                )}
                {isThirdOpt && (
                  <button onClick={() => confirmCaseDoc()}>
                    Confirm Document
                  </button>
                )}
              </div>

              {currectdoc.filenames.length == 0 && (
                <h2>
                  {profile.role.name === "CFO" ? (
                    "Please inform the legal counsel to upload their exhibit documents"
                  ) : (
                    <>
                      {isPaid
                        ? "You are yet to upload the file. Go to the upload link."
                        : "Legal Counsel need to re-upload the document."}

                      {isPaid && (
                        <Link to={`/affidavit-upload/${docUploadId}`}>
                          <span>Upload Files</span>{" "}
                        </Link>
                      )}
                    </>
                  )}
                </h2>
              )}
            </div>
          </div>
          {doctype!='rework' && isCommissioned && (
            <div className="action_wrapper no-print">
              <JisButton
                variant="primary"
                type="button"
                onClick={() => {
                  const imageUrls = pdfdoc.filenames.map((f) =>
                    Constants.AbsoluteFiletoRelative(f)
                  );
                  const printWindow = window.open("", "_blank");
                  printWindow.document.write(`<!DOCTYPE html>
<html>
<head>
  <title>Print Document</title>
  <style>
    body { margin: 0; padding: 0; background: white; }
    img { display: block; width: 100%; page-break-after: always; }
    img:last-child { page-break-after: auto; }
    * { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
  </style>
</head>
<body>${imageUrls.map((url) => `<img src="${url}" />`).join("")}</body>
</html>`);
                  printWindow.document.close();
                  printWindow.focus();
                  printWindow.onload = () => {
                    printWindow.print();
                    printWindow.close();
                  };
                }}
              >
                Print Document
              </JisButton>
            </div>
          )}
          
          {(doctype=='rework' || !isCommissioned) && (
            <div className="action_wrapper">
          {((currectdoc.upline?.isRework==true || doctype=='rework') && isLegal ) && 
            <div className="action_wrapper"> 
                  <JisButton variant="outline" type="button" onClick={onReuploadDocument}>
                    Replace/Change Document
                  </JisButton>
                  <JisButton variant="outline" type="button" onClick={onReworkCompleted}>
                    Rework Completed
                  </JisButton>
            </div>}
              {!isLegal && (
                <div className="cfo-create-submit-btn cfo-create-submit-action-btn">
                  <JisButton
                    variant="primary"
                    type="button"
                    onClick={onSchedule}
                  >
                    {scheduleButtonText}
                  </JisButton>
                  <JisButton variant="outline" type="button" onClick={()=>setRework({openRework:true})}>
                    Rework Document
                  </JisButton>
                </div>
              )}
              {isCfo && (
                <VirtualCallAudit
                  docId={currectdoc?.upline?.id}
                  caseId={docInfo?.caseId}
                />
              )}
              <div className="actions">
                <div>
                  <p className="title">E-swearing Actions</p>
                  <p className="description">
                    Digitally signed and authorized seals, signatures, and time
                    stamps
                  </p>
                </div>

                {!isLegal &&
                  permissionList.has(currectdoc.upline?.gazetteItemId) && (
                    <div className="check-sign">
                      <div className="cfo_input">
                        <input
                          type="checkbox"
                          id="check-cfo"
                          checked={currectdoc.upline?.allowSign}
                          disabled={currectdoc.upline?.allowSign}
                          onChange={(e) => onAllowSign(e)}
                        />
                        <label htmlFor="check-cfo">
                          Allow to Append Signature
                        </label>
                      </div>
                      {/* <div className="cfo_input">
                      <input
                        type="checkbox"
                        checked={currectdoc.upline?.allowSeal}
                        id="check-cfo"
                        disabled={currectdoc.upline?.allowSeal}
                        onChange={(e) => onAllowSeal(e)}
                      />
                      <label htmlFor="check-cfo">Allow to Append Seal</label>
                    </div> */}
                    </div>
                  )}

                {permissionList.has(currectdoc.upline?.gazetteItemId) && (
                  <div>
                    {currectdoc.upline?.allowSign ? (
                      <span style={{ color: green[500], fontWeight: "bold" }}>
                        permission granted for you to append your
                        signature/seal{" "}
                      </span>
                    ) : (
                      <span style={{ color: red[500], fontWeight: "bold" }}>
                        Permission required for item{" "}
                      </span>
                    )}
                  </div>
                )}

                {isLegal ? (
                  <div className="btns" style={{ flexWrap: "wrap" }}>
                    <div className="append">
                      <div className="append-img-card-container">
                        <div className="append-img-container">
                          {seal && (
                            <img
                              src={seal == "" ? Seal : seal}
                              alt="Seal"
                              // style={{ height: 100 }}
                            />
                          )}
                        </div>

                        <p>{seal !== "" ? "Seal" : "----"}</p>
                      </div>

                      <div>
                        <div className="upload-btn">
                          <input
                            type="file"
                            id="append-seal"
                            accept="image/*"
                            onChange={(e) => previewImage(e, "Seal")}
                          />
                          <label
                            htmlFor={`append-seal`}
                            className="upload-btn-text"
                          >
                            Upload Seal
                          </label>
                        </div>
                        <button className="append-btn" onClick={onAppendSeal}>
                          Append Seal
                        </button>
                      </div>
                    </div>
                    <div className="append">
                      <div className="append-img-card-container">
                        <div className="append-img-container">
                          {sign && (
                            <img
                              // src={sign == "" ? Sign : sign}
                              src={sign}
                              alt="Signature"
                              // style={{ height: 100 }}
                            />
                          )}
                        </div>

                        <p>{sign !== "" ? "Signature" : "----"}</p>
                      </div>

                      <div>
                        <div className="upload-btn">
                          <input
                            type="file"
                            id="append-sign"
                            accept="image/*"
                            onChange={(e) => previewImage(e, "Signature")}
                          />
                          <label htmlFor={`append-sign`}>Upload Sign</label>
                        </div>
                        <button
                          className="append-btn"
                          onClick={onAppendSignature}
                        >
                          Append Signature
                        </button>
                      </div>
                    </div>

                    <div className="append">
                      <div className="append-img-card-container">
                        <div className="append-img-container">
                          {passport && (
                            <img
                              //   src={passport == "" ? Sign : passport}
                              src={passport}
                              alt="Passport"
                              // style={{ height: 100 }}
                            />
                          )}
                        </div>
                        <p>{passport !== "" ? "Passport" : "----"}</p>
                      </div>

                      <div>
                        <div className="upload-btn">
                          <input
                            type="file"
                            id="append-passport"
                            accept="image/*"
                            onChange={(e) => previewImage(e, "Passport")}
                          />
                          <label htmlFor={`append-passport`}>
                            Upload Passport
                          </label>
                        </div>
                        <button
                          className="append-btn"
                          onClick={onAppendPassport}
                        >
                          Append Passport
                        </button>
                      </div>
                    </div>

                    <div className="append">
                      <div className="append-img-card-container">
                        <div className="append-img-container">
                          {stamp && (
                            <img
                              // src={stamp == "" ? Sign : stamp}
                              src={stamp}
                              alt="Stamp"
                              // style={{ height: 100 }}
                            />
                          )}
                        </div>

                        <p>{stamp !== "" ? "Signature" : "----"}</p>
                      </div>
                      <div>
                        <div className="upload-btn">
                          <input
                            type="file"
                            id="append-stamp"
                            accept="image/*"
                            onChange={(e) => previewImage(e, "Stamp")}
                          />
                          <label htmlFor={`append-stamp`}>Upload Stamp</label>
                        </div>
                        <button className="append-btn" onClick={onAppendStamp}>
                          Append Stamp
                        </button>
                      </div>
                    </div>
                    <div className="append">
                      <div style={{ width: 100, height: 100 }}></div>
                      <div className="append-create">
                        <input
                          type="text"
                          id="append-time-stamp"
                          value={moment(currentdate).format(
                            "DD/MM/YYYY hh:mm a",
                          )}
                          disabled={true}
                        />
                      </div>
                      <JisButton onClick={onAppendTimestamp}>
                        Append Timestamp
                      </JisButton>
                    </div>

                    <div className="append append-time-stamp-container">
                      <div className="append-img-card-container">
                        <input
                          type="text"
                          id="append-time-stamp"
                          value={moment(currentdate).format(
                            "DD/MM/YYYY hh:mm a",
                          )}
                          disabled={true}
                        />
                      </div>
                      <button
                        className="append-btn"
                        onClick={onAppendTimestamp}
                      >
                        Append Timestamp
                      </button>
                      {/* </div> */}
                    </div>
                  </div>
                ) : (
                  <div className="btns" style={{ flexWrap: "wrap" }}>
                    <div className="append">
                      <div className="append-img-card-container">
                        <div className="append-img-container">
                          {seal && (
                            <img
                              // src={seal == "" ? Seal : seal}
                              src={seal}
                              alt="Seal"
                              //   style={{ height: 100 }}
                            />
                          )}
                        </div>
                        <p>{seal !== "" ? "CFO Seal" : "----"}</p>
                      </div>

                      <div>
                        <div className="upload-btn">
                          <input
                            type="file"
                            id="append-seal"
                            accept="image/*"
                            onChange={(e) => previewImage(e, "Seal")}
                          />
                          <label htmlFor={`append-seal`}>Upload Seal</label>
                        </div>
                        <button className="append-btn" onClick={onAppendSeal}>
                          Append {isCfo && "CFO"} Seal
                        </button>
                      </div>
                    </div>
                    <div className="append">
                      <div className="append-img-card-container">
                        <div className="append-img-container">
                          {cashier_seal && (
                            <img
                              src={cashier_seal}
                              alt="Cashier Seal"
                              //   style={{ height: 150 }}
                            />
                          )}
                        </div>
                        <p>{cashier_seal !== "" ? "Cashier Seal" : "----"}</p>
                      </div>

                      <button
                        className="append-btn"
                        onClick={onAppendCashierSeal}
                      >
                        Append Cashier Seal
                      </button>
                    </div>
                    <div className="append">
                      <div className="append-img-card-container">
                        <div className="append-img-container">
                          {cashier_stamp && (
                            <img
                              src={cashier_stamp}
                              alt="Cashier Stamp"
                              //   style={{ height: 150 }}
                            />
                          )}
                        </div>
                        <p>{cashier_stamp !== "" ? "Cashier Stamp" : "----"}</p>
                      </div>

                      <button
                        className="append-btn"
                        onClick={onAppendCashierStamp}
                      >
                        Append Cashier Stamp
                      </button>
                    </div>
                    <div className="append">
                      <div className="append-img-card-container">
                        <div className="append-img-container">
                          {sign && (
                            <img
                              // src={sign == "" ? Sign : sign}
                              src={sign}
                              alt="Signature"
                              //   style={{ height: 100 }}
                            />
                          )}
                        </div>
                        <p>{sign !== "" ? "CFO Signature" : "----"}</p>
                      </div>
                      <div>
                        <div className="upload-btn">
                          <input
                            type="file"
                            id="append-sign"
                            accept="image/*"
                            onChange={(e) => previewImage(e, "Signature")}
                          />
                          <label htmlFor={`append-sign`}>Upload Sign</label>
                        </div>
                        <button
                          className="append-btn"
                          onClick={onAppendSignature}
                        >
                          Append CFO Signature
                        </button>
                      </div>
                    </div>

                    <div className="append">
                      <div className="append-img-card-container">
                        <div className="append-img-container">
                          {initial && (
                            <img
                              // src={initial == "" ? Sign : initial}
                              src={initial}
                              alt="Initial"
                              style={{ height: 100 }}
                            />
                          )}{" "}
                        </div>

                        <p>{initial !== "" ? "CFO Initial" : "----"}</p>
                      </div>

                      <div>
                        <div className="upload-btn">
                          <input
                            type="file"
                            id="append-sign"
                            accept="image/*"
                            onChange={(e) => previewImage(e, "Initial")}
                          />
                          <label htmlFor={`append-sign`}>Upload Sign</label>
                        </div>
                        <button
                          className="append-btn"
                          onClick={onAppendInitial}
                        >
                          Append CFO Initial
                        </button>
                      </div>
                    </div>

                    <div className="append">
                      <div className="append-img-card-container">
                        <div className="append-img-container">
                          {stamp && (
                            <img
                              // src={stamp == "" ? Sign : stamp}
                              src={stamp}
                              alt="Stamp"
                              style={{ height: 100 }}
                            />
                          )}{" "}
                        </div>

                        <p>{stamp !== "" ? "CFO Stamp" : "----"}</p>
                      </div>

                      <div>
                        <div className="upload-btn">
                          <input
                            type="file"
                            id="append-stamp"
                            accept="image/*"
                            onChange={(e) => previewImage(e, "Stamp")}
                          />
                          <label htmlFor={`append-stamp`}>Upload Stamp</label>
                        </div>
                        <button className="append-btn" onClick={onAppendStamp}>
                          Append {isCfo && "CFO"} Stamp
                        </button>
                      </div>
                    </div>
                    <div className="append append-time-stamp-container">
                      {/* <div style={{ height: 100 }}></div> */}
                      {/* <div> */}
                      {/* <div className="append-create">
                      </div> */}
                      <div className="append-img-card-container">
                        <input
                          type="text"
                          id="append-time-stamp"
                          value={moment(currentdate).format(
                            "DD/MM/YYYY hh:mm a",
                          )}
                          disabled={true}
                        />
                      </div>
                      <button
                        className="append-btn"
                        onClick={onAppendTimestamp}
                      >
                        Append Timestamp
                      </button>
                      {/* </div> */}
                    </div>
                    <div className="append append-time-stamp-container">
                      {/* <div style={{ height: 100 }}></div> */}
                      {/* <div className="append-create"> */}
                      <div className="append-img-card-container">
                        <input
                          type="text"
                          id="append-time-stamp"
                          value={moment(currentdate).format(
                            "DD/MM/YYYY hh:mm a",
                          )}
                          disabled={true}
                        />
                      </div>
                      <button
                        className="append-btn"
                        onClick={onAppendTimestamp2}
                      >
                        Append Timestamp 2
                      </button>
                    </div>
                  </div>
                )}

                <div className="instrument-footer">
                  {/* <p className="timestamp">
                  Time stamp: {moment(currentdate).format("DD/MM/YYYY hh:mm a")}
                </p> */}
                  <button
                    className="save-instrument-btn"
                    onClick={onSavePostion}
                  >
                    Save Instrument Positioning
                  </button>
                </div>
                {/* <div>
              <p style={{ color: "red" }}>
                <DynamicIcon iname="info" /> Click this button after appending
                all media to each document before moving to the next document{" "}
              </p>
            </div> */}
              </div>
            </div>
          )}
        </div>
      </div>
      {cfoWarn && (
        <div className={"warning show"}>
          <div className="container">
            <div className="icon" onClick={() => setCfoWarn(false)}>
              <DynamicIcon iname="close" />
            </div>
            <div className="body">
              <h3>Appending Signature</h3>
              <p>
                You are not allowed to upload your signature yet. Please wait
                for the Chief for Oath (CFO) authorizes you to upload your
                signature. In the mean time, you can upload your seal and
                passport{" "}
              </p>
              <button onClick={() => setCfoWarn(false)}>Ok</button>
            </div>
          </div>
        </div>
      )}

      <BackLoader open={isLoading} />
      <JisPrompt {...imgPrev} onOk={onAgree}>
        <p
          style={{
            flexDirection: "row",
            alignContent: "center",
            alignItems: "center",
          }}
        >
          {imgPrev.data != null && (
            <img
              src={imgPrev.data}
              style={{ height: 100 }}
              alt={imgPrev.type}
            />
          )}
          <strong>
            Are you ready to save this {imgPrev.type} {imgPrev.file?.name} ?
          </strong>
        </p>
      </JisPrompt>
      {alert.open && <JisAlert {...alert} />}
      <JisPrompt {...prompt}>
        <p>{prompt.subtitle}</p>
      </JisPrompt>
      {rework.openRework && 
      <JisDialogForm title="Document Rework" onClose={onCloseRework}>
        <div>
            <h2>Document Rework</h2>
            <form onSubmit={onSaveRework}>
                <div className="input-group">
                    <label>Rework Reason</label>
                    <div className="input-wrapper">
                    <DynamicIcon iname="group" />
                    <textarea value={rework.reason} onChange={(e)=>setRework({...rework,reason:e.target.value})}
                     maxLength={300} required placeholder="Please enter the rework reason">
                    </textarea> 
                </div>
                </div>
                <div style={{textAlign:'center'}}>
                    <JisButton  type="submit">
                    Save
                  </JisButton>
                </div>  
            </form>
        </div>
        </JisDialogForm>
        }
          {isPreview && (
            <div className={"preview open"} style={{ overflow: "scroll" }}>
              <div className="heading">
                <div>
                  <JisButton icon="close" onClick={() => setIsPreview(false)}>
                    {" "}
                    Close Preview
                  </JisButton>
                </div>
              </div>
              <PdfViewer pdfUrl={previewPath} />

              <div className="date-btns"></div>
            </div>
          )}
{isReplace && 
      <JisDialogForm title="Replace Document" onClose={onCloseChange}>

        <div>
            <h2>Replace Document</h2>
            <form onSubmit={onSaveRework}>
                <div style={{ display: "flex", marginTop: 8 }}>
                  <div className="btn-upload">
                    <input
                      type="file"
                      accept="application/pdf"
                      id="settlement-file-upload"
                      onChange={(e) => handleUploadChange(e)}  />
                    <label
                      htmlFor="settlement-file-upload"
                      title={sFile?.filename}>
                      {sFile?.path == null
                        ? "Choose File"
                        : Constants.ReduceString(sFile?.filename, 30)}
                    </label>
                   {/*  {sFile?.path != null && (
                      <JisButton onClick={() => onPreview(sFile)}>
                        Preview
                      </JisButton>
                    )} */}
                  </div>
                  {sFile?.path != null && (
                    <JisButton type="button" onClick={onSaveFile}>
                      Save File
                    </JisButton>
                  )}
                </div>
            </form>
        </div>
        </JisDialogForm>
        }
        
    </div>
  );
}

export default JisPreparePdf;
